// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-AutoExclusions-AutoExclusionsPage-module__feedbackButton";
var _2 = "webpack-pages-AutoExclusions-AutoExclusionsPage-module__pageContainer";
export { _1 as "feedbackButton", _2 as "pageContainer" }
